import { render, staticRenderFns } from "./Adv.vue?vue&type=template&id=c27122a8&scoped=true&"
import script from "./Adv.vue?vue&type=script&lang=js&"
export * from "./Adv.vue?vue&type=script&lang=js&"
import style0 from "./Adv.vue?vue&type=style&index=0&id=c27122a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27122a8",
  null
  
)

export default component.exports